// Marker class, used as interface
export abstract class Parent {
  isReadOnly?: () => boolean;
}